import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Gallery2 } from "./components/gallery2";
import { Gallery3 } from "./components/gallery3";
import { Gallery4 } from "./components/gallery4";
import { Gallery5 } from "./components/gallery5";
import { Gallery6 } from "./components/gallery6";
import { Gallery7 } from "./components/gallery7";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
/*import { Contact } from "./components/contact";*/
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />
      <Features data={landingPageData.Features} />
      <About data={landingPageData.About} />
      <Services data={landingPageData.Services} />
      <Gallery7 data={landingPageData.Gallery7} />
      <Gallery data={landingPageData.Gallery} />
      <Gallery2 data={landingPageData.Gallery2} />
      <Gallery3 data={landingPageData.Gallery3} />
      <Gallery4 data={landingPageData.Gallery4} />
      <Gallery5 data={landingPageData.Gallery5} />
      <Gallery6 data={landingPageData.Gallery6} />
      <Testimonials data={landingPageData.Testimonials} />
      <Team data={landingPageData.Team} />
      {/* <!-- <Contact data={landingPageData.Contact} /> --> */}
    </div>
  );
};

export default App;
